import { SESSION_STORAGE_KEYS } from "../../constants";
import { useDpConfig } from "../../contexts/dpConfig";
import { AnnouncementIcon, CloseIcon } from "../../assets/icons";
import { openSaasMarketplaceInterstitial } from "../../utils/saasMarketplaceInterstitialEvents";
import { useSessionDismissFlag } from "../../hooks/useSessionDismissFlag";

const SaasMarketplaceTopBanner = () => {
  const {
    state: { settings },
  } = useDpConfig();
  const cfg = settings.saasMarketplaceBanner;
  const [dismissed, dismiss] = useSessionDismissFlag(
    SESSION_STORAGE_KEYS.SAAS_MARKETPLACE_TOP_BANNER_DISMISSED
  );

  const canOpenInterstitial = Boolean(cfg?.interstitial?.imageUrl?.trim());

  if (
    dismissed ||
    !cfg?.enabled ||
    !cfg.topBanner?.headline?.trim() ||
    !cfg.topBanner.ctaLabel?.trim() ||
    !canOpenInterstitial
  ) {
    return null;
  }

  const { headline, subCopy, ctaLabel } = cfg.topBanner;

  return (
    <div className="cx-w-full cx-shrink-0 cx-z-30 cx-bg-[linear-gradient(108deg,#EDA3FC_12.18%,#7553DB_36.36%,#2529EB_62.54%,#01B2FF_87.82%)]">
      <div className="cx-relative cx-w-full">
        <div className="cx-max-w-[1000px] cx-mx-auto cx-py-2.5 cx-flex cx-items-center cx-gap-2 cx-text-white">
          <AnnouncementIcon className="cx-flex-shrink-0 cx-w-7 cx-h-7 cx-opacity-95" />
          <div className="cx-min-w-0 cx-flex-1 cx-text-[15px] cx-leading-tight sm:cx-whitespace-nowrap">
            <span className="cx-font-normal">{headline}</span>
            {subCopy?.trim() ? (
              <span
                className="cx-block sm:cx-inline sm:cx-ml-1 cx-mt-0.5 sm:cx-mt-0 [&_b]:cx-font-bold [&_strong]:cx-font-bold"
                // Sub-copy is managed by trusted DP config and may include inline tags.
                dangerouslySetInnerHTML={{ __html: subCopy }}
              />
            ) : null}
          </div>
          <button
            type="button"
            onClick={() => openSaasMarketplaceInterstitial()}
            className="cx-flex-shrink-0 cx-inline-flex cx-font-medium cx-items-center cx-justify-center cx-rounded-full cx-bg-white cx-text-text-primary cx-text-base  cx-px-12 cx-py-1 cx-no-underline hover:cx-opacity-95 cx-transition-opacity cx-cursor-pointer"
          >
            {ctaLabel}
          </button>
        </div>
        <button
          type="button"
          onClick={dismiss}
          className="cx-absolute cx-right-2 cx-top-1/2 -cx-translate-y-1/2 cx-flex-shrink-0 cx-w-9 cx-h-9 cx-flex cx-items-center cx-justify-center cx-rounded-full hover:cx-bg-white/15 cx-transition-colors cx-text-white"
          aria-label="Dismiss promotion"
        >
          <CloseIcon className="cx-w-4 cx-h-4" />
        </button>
      </div>
    </div>
  );
};

export default SaasMarketplaceTopBanner;
